import { render, staticRenderFns } from "./DisplayField.vue?vue&type=template&id=20abf8fc&scoped=true&functional=true&"
import script from "./DisplayField.vue?vue&type=script&lang=js&"
export * from "./DisplayField.vue?vue&type=script&lang=js&"
import style0 from "./DisplayField.vue?vue&type=style&index=0&id=20abf8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "20abf8fc",
  null
  
)

export default component.exports